package com.anjuros.website.templates.template2.modules

import com.anjuros.website.templates.template2.util.ResKey


enum class Template2Section(
    val id: String,
    val headerTitle:ResKey,
    val title: ResKey,
    val subtitle: ResKey? = null,
    val path: String
) {

    Service(
        headerTitle = ResKey.TEMPLATE2_SECTION1,
        id = "service",
        title = ResKey.TEMPLATE2_SECTION1,
        path = "#service"
    ),
    Testimonial(
        headerTitle = ResKey.TEMPLATE2_SECTION2,
        id = "reviews",
        title = ResKey.TEMPLATE2_SECTION2,
        path = "#reviews"
    ),

    Contact(
        headerTitle = ResKey.TEMPLATE2_SECTION3,
        id = "contact",
        title = ResKey.TEMPLATE2_CONTACT_TITLE,
        subtitle = ResKey.TEMPLATE2_CONTACT_TEXT,
        path = "#contact"
    )
}